import { Alert, AlertColor, AlertProps } from '@mui/material';
import { styled } from '@mui/system';
import { AtlasTheme, WithTheme } from '@issuemanager/apps/client/theme';

function severityColorMap(theme: AtlasTheme, severity: AlertColor = 'info') {
  const map = {
    error: theme.tokens.semantic.color.status.error.value,
    success: theme.tokens.semantic.color.status.success.value,
    info: theme.tokens.semantic.color.status.new.value,
    warning: theme.tokens.semantic.color.status.warning.value,
  };
  return map[severity];
}

export const StyledAlert = styled(Alert)<WithTheme<AlertProps>>(
  ({ theme, severity }) => ({
    borderLeftColor: severityColorMap(theme, severity),
    borderLeftStyle: 'solid',
    borderLeftWidth: '6px',
    backgroundColor: theme.tokens.semantic.color.background.container.value,
    boxShadow: theme.tokens.core.shadow.low.value.stringValue,
    alignItems: 'center',
    '.MuiAlert-icon': {
      color: severityColorMap(theme, severity),
    },
    '.MuiAlertTitle-root': {
      color: severityColorMap(theme, severity),
    },
  }),
);
